import {BookingBookingPostBody} from '../../../services/booking/types'

const processNestedKeys = (keys: string[], value: string, json: any): void => {
  let current = json

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < keys.length - 1; i++) {
    const part = keys[i]
    current[part] = current[part] ?? {}
    current = current[part]
  }

  current[keys[keys.length - 1]] = value
}

const buildJsonFromParams = (params: URLSearchParams): Partial<BookingBookingPostBody> => {
  const json: Partial<BookingBookingPostBody> = {}

  params.forEach((value, key) => {
    const keys = key.split('[').map(k => k.replace(']', ''))
    processNestedKeys(keys, value, json)
  })

  return json
}

export const parseQueryString = (): Partial<BookingBookingPostBody> => {
  const params = new URLSearchParams(window.location.search)
  return buildJsonFromParams(params)
}
